<!-- メニューバー -->
<div class="menu-bar p-d-flex" [class.large-menu-bar]="getTextSize()">
  <!-- メニュー -->
  <div class="menu p-d-flex">
    <div class="menu-wrapper p-as-center" [class.not-logedin]="!loginStatus">
      <p-menubar [model]="menuItems"></p-menubar>
    </div>
  </div>

  <div class="menu-sm-container"(click)="setDisplayHamburgerMenu($event,!isShowHamburgerMenu)">
    <div class="menu-sm" id="hbgBtn">
      <div class="hamburger-menu">
        <div class="icon">
          <i class="pi pi-bars"></i>
        </div>
        <div class="menu-label">メニュー</div>
      </div>
    </div>
  </div>

  <!-- ログイン済み -->
  <div class="in-login p-d-flex p-jc-end"
       [ngClass]="{'is-logged-out': !loginStatus}"
  >
    <div class="p-as-center" *ngIf="loginStatus">
      <button
        type="button"
        label="ユーザーメニュー"
        icon="pi pi-angle-down"
        iconPos="right"
        class="p-button-raised login-button"
        (click)="menu.toggle($event)"
        pButton
      ></button>
      <p-tieredMenu #menu [model]="loginItems" [popup]="true"></p-tieredMenu>
    </div>
  </div>
</div>
<div class="hamburger-overlay p-menu p-component p-menu-overlay" id="hbgM">
  <ul class="p-menu-list p-reset">
    <li
      class="p-menuitem"
      (click)="setDisplayHamburgerMenu($event,false)"
      *ngFor="let item of hamburgerMenuItems"
      [ngClass]="item.styleClass"
      [class.large-harmburger]="getTextSize()"
    >
      <a role="menuitem" class="p-menuitem-link" [href]="item.url" tabindex="0" *ngIf="item.url" [attr.target]="item.target ? item.target : null">
        <span class="p-menuitem-text ng-star-inserted">{{item.label}}</span>
      </a>

      <a role="menuitem" class="p-menuitem-link" tabindex="0" *ngIf="!item.url" [attr.target]="item.target ? item.target : null">
        <span class="p-menuitem-text ng-star-inserted">{{item.label}}</span>
      </a>
    </li>
  </ul>
</div>
<p-menu #hamburgerMenu [popup]="true" [model]="hamburgerMenuItems" styleClass="hamburger-overlay" [class.large-harmburger]="getTextSize()"></p-menu>
